import { render } from "./EmailLink.vue?vue&type=template&id=a75b0c8a&ts=true"
import script from "./EmailLink.vue?vue&type=script&lang=ts"
export * from "./EmailLink.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__